<template>
	<SOTagihan v-if="!tagihanTambahan">
		<template v-slot:status_lunas>
			<SOTagihanStatusLunas
				:transaksi="transaksi"
				:type-nota-transaksi="layananReguler"
				:type-nota-topup="topupEpayment || topupDeposit"
				:type-nota-transaksi-snapclean="snapcleanSelfService || snapcleanDropOff"
			/>
		</template>

		<template v-slot:header>
			<SOTagihanHeader
				:transaksi="transaksi"
				:snapclean-self-service="isSelfService"
				@detail="detail"
			/>
		</template>

		<template v-slot:layanan>
			<SOTagihanLayanan v-if="layananReguler" :transaksi="transaksi"/>
			<SOTagihanLayananSnapclean v-if="layananSnapclean" :transaksi="transaksi"/>
			<SOTagihanTopupDeposit v-if="topupDeposit" :transaksi="transaksi"/>
			<SOTagihanTopupEpayment v-if="topupEpayment" :transaksi="transaksi"/>
		</template>

		<template v-slot:biaya-tambahan>
			<SOTagihanBiayaTambahan :transaksi="transaksi"/>
		</template>

		<template v-slot:total-tagihan>
			<div class="m-d-16">
				<SOTagihanTotalTagihan :transaksi="transaksi"/>
			</div>

			<div class="separator-line m-d-16"></div>
		</template>

		<template v-slot:pembayaran>
			<SOPembayaranList :pembayaran="transaksi.rincian_pembayaran"/>
		</template>

		<template v-slot:total-pembayaran>
			<SOPembayaranTotalPembayaran
				:pembayaran="transaksi.rincian_pembayaran"
				:grandtotal="transaksi.detail_transaksi.grandtotal"
			/>
		</template>
		<template v-slot:benefit-non-discount v-if="hasNonDiscountBenefit()">
			<SOBenefitPromo :promo="transaksi.promo"/>
		</template>
	</SOTagihan>

	<SOTagihan v-else>
		<template v-slot:header>
			<SOTagihanHeader
				:transaksi="transaksi"
				:tagihan-tambahan="tagihanTambahan"
				:show-detail-tagihan-tambahan="showDetailTagihanTambahan"
				@detail="detail"
			/>
		</template>

		<template v-slot:layanan>
			<SOTagihanEkstraPengantaran
				:pengantaran-extra="transaksi.detail_transaksi.pengantaran_extra"
			/>
		</template>

		<template v-slot:total-tagihan>
			<div class="m-d-16">
				<SOTagihanTotalTagihan :transaksi="transaksi" :tagihan-tambahan="true"/>
			</div>

			<div class="separator-line m-d-16"></div>
		</template>

		<template v-slot:pembayaran>
			<SOPembayaranList :pembayaran="transaksi.detail_transaksi.pengantaran_extra_bayar"/>
		</template>

		<template v-slot:total-pembayaran>
			<SOPembayaranTotalPembayaran
				:pembayaran="transaksi.detail_transaksi.pengantaran_extra_bayar"
				:grandtotal="transaksi.detail_transaksi.pengantaran_extra.biaya"
				:tagihan-tambahan="true"
			/>
		</template>
	</SOTagihan>
</template>

<script>
import SOTagihan from "@/so-components/global/slot/SOTagihan";

import SOTagihanStatusLunas from "@/so-components/modules/transaksi/tagihan/SOTagihanStatusLunas";
import SOTagihanHeader from "@/so-components/modules/transaksi/tagihan/SOTagihanHeader";

import SOTagihanLayanan from "@/so-components/modules/transaksi/tagihan/SOTagihanLayanan";
import SOTagihanLayananSnapclean from "@/so-components/modules/transaksi/tagihan/SOTagihanLayananSnapclean";
import SOTagihanTopupDeposit from "@/so-components/modules/transaksi/tagihan/SOTagihanTopupDeposit";
import SOTagihanTopupEpayment from "@/so-components/modules/transaksi/tagihan/SOTagihanTopupEpayment";
import SOTagihanEkstraPengantaran from "@/so-components/modules/transaksi/tagihan/SOTagihanEkstraPengantaran";

import SOTagihanBiayaTambahan from "@/so-components/modules/transaksi/tagihan/SOTagihanBiayaTambahan";
import SOTagihanTotalTagihan from "@/so-components/modules/transaksi/tagihan/SOTagihanTotalTagihan";

import SOPembayaranList from "@/so-components/modules/transaksi/pembayaran/SOPembayaranList";
import SOPembayaranTotalPembayaran from "@/so-components/modules/transaksi/pembayaran/SOPembayaranTotalPembayaran.vue";
import SOBenefitPromo from '../../tagihan/SOBenefitPromo.vue';


export default {
	name: "SOTransaksiDetailTagihan",
	components: {
		SOTagihan,

		SOTagihanStatusLunas,
		SOTagihanHeader,

		SOTagihanLayanan,
		SOTagihanLayananSnapclean,
		SOTagihanTopupDeposit,
		SOTagihanTopupEpayment,
		SOTagihanEkstraPengantaran,

		SOTagihanBiayaTambahan,
		SOTagihanTotalTagihan,

		SOPembayaranList,
		SOPembayaranTotalPembayaran,
		SOBenefitPromo,
	},
	props: {
		transaksi: Object,

		layananReguler: Boolean,
		layananSnapclean: Boolean,
		topupDeposit: Boolean,
		topupEpayment: Boolean,

		snapcleanSelfService: Boolean,
		snapcleanDropOff: Boolean,

		tagihanTambahan: Boolean,
		showDetailTagihanTambahan: Boolean,

		isSelfService: Boolean,
	},
	methods: {
		detail() {
			this.$emit("detail")
		},
		hasNonDiscountBenefit(){
			const benefit = this.transaksi?.promo?.non_discount
			if (benefit == null) {
				return false
			}
			const result = Object.keys(benefit).every(key => (
				benefit[key] == null
			));
			return !result
		}
	}
}
</script>

<style scoped>
.separator-line {
	border-top: 3px solid #C8D0DD;
}
</style>